<template>
  <div class="difference-container" v-if="hasValueDiference">
    <h3>
      Diferença de valores({{ title }}) -
      {{ valueDiference > 0 ? 'Recebimento' : 'Despesa' }}
    </h3>
    <div class="form-group">
      <span class="label label-primary pull-right">
        Diferença: R$ {{ valueDiference.toFixed(2) }}
      </span>
    </div>
    <div class="difference-content">
      <div class="form-group col-md-6">
        <label>Descrição:</label>
        <input
          type="text"
          class="form-control"
          placeholder="Digite uma descrição"
          v-model="form.description"
        />
      </div>
      <div class="form-group col-md-6">
        <label>Label</label>
        <tags-input
          :tags="labelsForDisplay"
          placeholder="Insira uma label"
          :select="true"
          :select-items="availableLabels"
          @on-select="addLabel"
          @on-tags-changed="syncLabels"
        >
          <template #select-item="slotProps">
            {{ slotProps.value }}
          </template>
        </tags-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    labelsForDisplay() {
      return this.form.labels.map((l) => l.value);
    },
    availableLabels() {
      const selectedKeys = this.form.labels.map((l) => l.key);
      return this.existentLabels.filter((l) => !selectedKeys.includes(l.key));
    },
  },
  methods: {
    addLabel(item) {
      if (!this.form.labels.find((l) => l.key === item.key)) {
        this.form.labels.push(item);
      }
    },
    syncLabels(tags) {
      this.form.labels = this.existentLabels.filter((l) =>
        tags.includes(l.value),
      );
    },
  },
  props: {
    hasValueDiference: {
      default: false,
    },
    title: {
      default: '',
    },
    valueDiference: {
      default: '',
    },
    existentLabels: {
      default: [],
    },
  },
  data() {
    return {
      form: {
        description: 'Diferença de fechamento de caixa em ' + this.title,
        labels: [],
      },
    };
  },
};
</script>